import { render } from "./formupload.component.vue?vue&type=template&id=da6149a6&ts=true"
import script from "./formupload.component.vue?vue&type=script&lang=ts"
export * from "./formupload.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__